module.exports = __webpack_public_path__ + "assets/img/6-2.f6c695e6.png";